import { z } from "zod";

export const AddConfigAdminsSchema = z.object({
  userId: z.number().optional(),
});

export const AddConfigAdminsDefaultValues = {
  userId: undefined as number | undefined,
};

export type TAddConfigAdminsSchema = z.infer<typeof AddConfigAdminsSchema>;
